import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlSnrBondFieldsFragment = { id: string, filingYear: string, filingNumber: string, registrationDate: string, serialNumber: string, bondType: string, decisionDate?: string | null, decisionBy?: string | null, partRegistration: boolean, shareClass?: string | null, shareCapitalCanBeIncreaseBy?: string | null, shareCapitalCanBeIncreaseByCurrency?: string | null, freetext?: string | null, warrantSubFrom?: string | null, warrantSubTo?: string | null, numberOfOptions?: string | null, numberOfSharesMax?: string | null, withoutLoan?: boolean | null, shareSubStartDate?: string | null, shareSubEndDate?: string | null, numberOfOptionsMax?: string | null, numberOfOptionsMin?: string | null, companyId: string, createdAt: string, updatedAt: string };

export const SnrBondFieldsFragmentDoc = gql`
    fragment SnrBondFields on SnrBond {
  id
  filingYear
  filingNumber
  registrationDate
  serialNumber
  bondType
  decisionDate
  decisionBy
  partRegistration
  shareClass
  shareCapitalCanBeIncreaseBy
  shareCapitalCanBeIncreaseByCurrency
  freetext
  warrantSubFrom
  warrantSubTo
  numberOfOptions
  numberOfSharesMax
  withoutLoan
  shareSubStartDate
  shareSubEndDate
  numberOfOptionsMax
  numberOfOptionsMin
  companyId
  createdAt
  updatedAt
}
    `;